import { Page, View, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { SafeImage } from '../../components/SafeImage';
import { useMemo } from 'react';
import { getImageSrc } from '@utils/fn';

export interface IntermediatePageProps {
  event: PublicEventDetailsResponse;
  header: JSX.Element;
  footer: JSX.Element;
}

const IntermediatePage = ({ event, header, footer }: IntermediatePageProps) => {
  const selectedTestimonial = useMemo(() => {
    const testimonials = event?.website_content?.testimonials;

    if (!testimonials?.length) return null;

    const valid = testimonials
      .filter(
        t => t?.first_name && t?.last_name && t?.citation && t?.company_name
      )
      .sort((a, b) => a.order - b.order);

    if (!valid.length) return null;

    const findByPriority = (key: 'is_partner' | 'is_home' | 'is_whoandwhy') =>
      valid.find(t => t[key]);

    const testimonial =
      findByPriority('is_partner') ||
      findByPriority('is_home') ||
      findByPriority('is_whoandwhy');

    if (!testimonial) return null;

    return {
      name: [testimonial.first_name, testimonial.last_name]
        .filter(Boolean)
        .join(' '),
      jobTitle: testimonial.job_title,
      companyName: testimonial.company_name,
      citation: testimonial.citation,
    };
  }, [event?.website_content?.testimonials]);

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      {header}

      <View style={styles.contentContainer}>
        <View style={styles.backgroundContainer}>
          <SafeImage
            src={getImageSrc(
              'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_testimonials.jpg'
            )}
            style={styles.backgroundImage}
            debugLabel="agenda-intermediate-background"
          />

          {selectedTestimonial && (
            <View style={styles.overlayContent}>
              <Text style={styles.title}>{selectedTestimonial.citation}</Text>
              <Text style={styles.subtitle}>
                {selectedTestimonial.jobTitle},
              </Text>
              <Text style={styles.subtitle}>
                {selectedTestimonial.companyName}
              </Text>
            </View>
          )}
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default IntermediatePage;
